export const always = () => true;

export const isAdmin = ({ user }) => Boolean(user.isAdmin || user.isSuperadmin);

export const isSuperadmin = ({ user }) => Boolean(user.isSuperadmin);

export const seesOutreachCommission = (ctx) =>
  isSuperadmin(ctx) || (isAdmin(ctx) && Boolean(ctx.user.roles?.isSalesperson));

export const isAffiliate = ({ user }) => Boolean(user.isAffiliate);

/* Admins get an empty user.shops, because they can open every shop. */
export const hasShopAccess = (ctx) =>
  isAdmin(ctx) || (ctx.user.shops?.length ?? 0) > 0;

export const hasShop = ({ activeInfluencer }) =>
  Boolean(activeInfluencer?.influencerId);

const isAgentOrTc = ({ activeInfluencer: shop }) =>
  shop.isAgentShop || shop.isTcShop;

export const canBuildShop = (ctx) =>
  hasShop(ctx) &&
  !isAgentOrTc(ctx) &&
  (!ctx.activeInfluencer.hasNoShopEditor || isAdmin(ctx));

export const sellsDirectly = (ctx) =>
  hasShop(ctx) && !isAgentOrTc(ctx) && !ctx.activeInfluencer.isGroupShop;

export const runsEvents = (ctx) => hasShop(ctx) && !isAgentOrTc(ctx);

export const isNotTcShop = (ctx) =>
  hasShop(ctx) && !ctx.activeInfluencer.isTcShop;

export const isAdminAtShop = (ctx) => hasShop(ctx) && isAdmin(ctx);

export const seesShopReporting = (ctx) =>
  hasShop(ctx) &&
  Boolean(ctx.activeInfluencer.isAgentShop) &&
  Boolean(ctx.flags.AGENT_REPORTING_ENABLED);

export const seesReports = (ctx) =>
  isAdmin(ctx) && Boolean(ctx.flags.REPORTS_ENABLED);
